import React, { useState, useEffect } from 'react';
import './index.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeart, faTag } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner';
import imagemPadrao from '../../../shared/assets/logoCard.svg';
import { useAuth } from '../../../context/AuthContext';

interface CardProps {
    cdAnuncio: number;
    cdUsuario: number;
    imagem?: string;
    titulo: string;
    descricao: string;
    tipoAnuncio: string;
    cidade: string;
    uf: string;
    preco: string;
    loading: boolean;
    isFavorito?: boolean;
    onClickFavoritar: (cdAnuncio: number) => void;
    favoritado: boolean;
}

const CardAnuncioHome: React.FC<CardProps> = ({ cdAnuncio, cdUsuario, imagem, titulo, descricao, tipoAnuncio, cidade, uf, preco, loading, isFavorito, onClickFavoritar, favoritado }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        if (!imagem) {
            setImageLoaded(true);
        }
    }, [imagem]);

    const handleImageLoad = () => {
        setImageLoaded(true);
    };

    const handleImageError = () => {
        setImageError(true);
        setImageLoaded(true);
    };

    const acaoFavoritar = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        event.preventDefault();
        onClickFavoritar(cdAnuncio);
    };

    const isAnuncioDoUsuario = user?.cdUsuario.toString() === cdUsuario.toString();

    return (
        <Link to={`/milshop/anuncio/ver-detalhes/${cdAnuncio}`} className='linkNavegacaoCardAnuncio'>
            <div className='containerCard'>
                <div className='secaoImagemCard'>
                    {loading && <Spinner animation="border" role="status" className="spinnerImage"><span className="sr-only">Carregando...</span></Spinner>}
                    {!loading && (
                        <img
                            src={imageError ? imagemPadrao : imagem}
                            alt={titulo}
                            onLoad={handleImageLoad}
                            onError={handleImageError}
                            style={{ display: imageLoaded ? 'block' : 'none' }}
                        />
                    )}
                </div>
                <div className='secaoInformacoesCard'>
                    <h1 className='tituloDoCard'>{titulo}</h1>
                    <p>{descricao}</p>
                    <p className='informacoesAnuncioCard'>{tipoAnuncio} - {cidade} - {uf}</p>
                </div>
                <div className='secaoPrecoCard'>
                    <p>{preco}</p>
                    {isAuthenticated && !isAnuncioDoUsuario && (
                        <FontAwesomeIcon
                            icon={faHeart}
                            color={favoritado ? '#7B0323' : 'grey'}
                            className='iconeFavoritar'
                            onClick={acaoFavoritar}
                        />
                    )}
                    {isAnuncioDoUsuario && isAuthenticated && <div className='meuAnuncio'> <FontAwesomeIcon
                            icon={faTag}
                            color={'#eb9b00'}
                        /> <p >Criado por você!</p> </div> }
                </div>
            </div>
        </Link>
    );
};

export default CardAnuncioHome;
